(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-badge-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-benefit-open]');

    if (openButton) {
      const modalId = openButton.getAttribute('data-benefit-open');
      const modal = document.getElementById(modalId);

      if (modal && typeof modal.showModal === 'function') {
        modal.showModal();
      }

      return;
    }

    const closeButton = event.target.closest('[data-benefit-close]');

    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (
      event.target.matches('.benefit-modal') &&
      event.target.open
    ) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
